"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApiErrorHandler = void 0;
var react_1 = require("react");
var axios_1 = __importDefault(require("axios"));
var lodash_1 = require("lodash");
var context_1 = require("../../context");
var useApiErrorHandler = function (_a) {
    var _b = _a.responseMessagePath, responseMessagePath = _b === void 0 ? 'message' : _b, _c = _a.alertContext, alertContext = _c === void 0 ? (0, context_1.useAlertContext)() : _c, _d = _a.snackbarContext, snackbarContext = _d === void 0 ? (0, context_1.useSnackbarContext)() : _d;
    var getMessage = (0, react_1.useCallback)(function (e) {
        var _a;
        return (0, lodash_1.get)((_a = e.response) === null || _a === void 0 ? void 0 : _a.data, responseMessagePath, null);
    }, [responseMessagePath]);
    var handler = (0, react_1.useCallback)(function (title, e, type) {
        if (type === void 0) { type = 'snack'; }
        var message = axios_1.default.isAxiosError(e) ? getMessage(e) : e.message;
        if (!message) {
            return;
        }
        if (type === 'snack') {
            snackbarContext.push({ text: title, details: message });
        }
        if (type === 'alert') {
            alertContext.push({
                title: title,
                text: message
            });
        }
    }, [snackbarContext, alertContext]);
    return handler;
};
exports.useApiErrorHandler = useApiErrorHandler;
